var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _CollectClient_apiInterface;
import { CollectApi } from "./api";
import { Treesponse } from "./treesponse";
import { Treesponder } from "./treesponder";
export class CollectClient {
    constructor(url, projectKey) {
        _CollectClient_apiInterface.set(this, void 0);
        Object.defineProperty(this, "treesponder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "treesponses", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        __classPrivateFieldSet(this, _CollectClient_apiInterface, new CollectApi(url, projectKey), "f");
        this.treesponder = new Treesponder(__classPrivateFieldGet(this, _CollectClient_apiInterface, "f"));
    }
    initTreesponse({ language, surveyVersion = "v1", initialAnswers, }) {
        const treesponse = new Treesponse(__classPrivateFieldGet(this, _CollectClient_apiInterface, "f"), this.treesponder, {
            language,
            surveyVersion,
        });
        treesponse.setAnswers(initialAnswers || {});
        this.treesponses.push(treesponse);
        return treesponse;
    }
}
_CollectClient_apiInterface = new WeakMap();
